"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_owl_carousel_1 = __importDefault(require("react-owl-carousel"));
require("owl.carousel/dist/assets/owl.carousel.css");
require("owl.carousel/dist/assets/owl.theme.default.css");
var utils_1 = require("../utils");
var HeaderComponent = function (_a) {
    var searchParams = _a.searchParams, setSearchParams = _a.setSearchParams, isLoading = _a.isLoading;
    var _b = react_1.useState(), categories = _b[0], setCategories = _b[1];
    var _c = react_1.useState(), provinces = _c[0], setProvinces = _c[1];
    react_1.useEffect(function () {
        utils_1.fetchProducts({ is_gkp: 1, list_category: 1, list_location: 1 }).then(function (res) {
            setCategories(res.data.categories);
            setProvinces(res.data.locations);
        });
    }, []);
    var handleClickCate = function (id, mode) {
        var _a;
        if (searchParams) {
            var newData_1 = [];
            var newParam = searchParams;
            if (!searchParams[mode] || searchParams['is_gkp']) {
                newData_1 = [id];
            }
            else {
                newData_1 = __spreadArray(__spreadArray([], searchParams[mode].split(",")), [
                    id,
                ]);
            }
            newData_1 = newData_1.filter(function (value, index) {
                return newData_1.indexOf(value) == index;
            });
            newParam = __assign(__assign({}, searchParams), (_a = {}, _a[mode] = newData_1.join(","), _a));
            //Reset pagination tiap perubahan filter
            delete newParam.pg;
            //Reset filter brand kalau kategori berubah
            if (mode === "category") {
                delete newParam.brand_id;
            }
            setSearchParams(newParam);
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: "col-md-12 col_choosenCat" },
            provinces && provinces.length > 0 && (react_1.default.createElement("div", { className: "bx_chcat_1 mb-4" },
                react_1.default.createElement("div", { className: "kategori-brand-header" },
                    react_1.default.createElement("h2", { className: "ht_choosenCat" }, "Daerah")),
                react_1.default.createElement("div", { className: "row row_chsCat" },
                    react_1.default.createElement(react_owl_carousel_1.default, { className: "owl-theme", items: 6, lazyLoad: true, margin: 10, responsive: {
                            0: {
                                items: 4,
                            },
                            768: {
                                items: 6,
                            },
                        } }, searchParams &&
                        (provinces === null || provinces === void 0 ? void 0 : provinces.map(function (province, index) { return (react_1.default.createElement("div", { key: Math.random() * 10, className: "item box-daerah", onClick: function () {
                                return handleClickCate(province.id.toString(), "province");
                            } },
                            react_1.default.createElement("h3", { className: "tx_choosenCat text-center" }, province.title))); })))))),
            categories && categories.length > 0 && (react_1.default.createElement("div", { className: "bx_chcat_1" },
                react_1.default.createElement("div", { className: "kategori-brand-header" },
                    react_1.default.createElement("h2", { className: "ht_choosenCat" }, "Kategori")),
                react_1.default.createElement("div", { className: "row row_chsCat" },
                    react_1.default.createElement(react_owl_carousel_1.default, { className: "owl-theme", items: 6, lazyLoad: true, margin: 10, responsive: {
                            0: {
                                items: 4,
                            },
                            768: {
                                items: 6,
                            },
                        } }, searchParams &&
                        (categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) { return (react_1.default.createElement("div", { key: Math.random() * 10, className: "item" },
                            react_1.default.createElement("a", { href: "#", onClick: function () {
                                    return handleClickCate(category.id.toString(), "category");
                                } },
                                react_1.default.createElement("div", { className: "mg_choosenCat2 " },
                                    react_1.default.createElement("img", { className: "lazy", src: category.image, title: category.title })),
                                react_1.default.createElement("h3", { className: "tx_choosenCat" }, category.title)))); })))))))));
};
exports.default = HeaderComponent;
